module.exports = __webpack_public_path__ + "0139b463a8934e807fad1cf823163280.png";